import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

interface ICSEDDisclaimerState {
    learnMore: boolean;
}

class CSEDDisclaimer extends React.Component<{}, ICSEDDisclaimerState> {

    constructor(_props: any) {
        super(_props);

        this.state = {
            learnMore: false
        }
    }

    public render() {
        return (
            <div style={{ textAlign: 'left' }}>
                <div>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ArrowDropDownIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Typography component="span">🟢 In-App Display</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                <div>⚠️ It’s possible that one or more of your tax periods may expire in the next 12 months under the IRS’s collection statute. While waiting for expiration could eliminate part of your balance, it also carries risk — the IRS may take enforcement action before the deadline. <a href="javascript:void(0)" onClick={() => {
                                    this.setState({
                                        learnMore: !this.state.learnMore
                                    })
                                }}>{this.state.learnMore ? 'View less' : 'Learn more'}</a></div>

                                {
                                    this.state.learnMore && <div>
                                        <p><b>Statute Expiration Disclaimer</b><br /> It appears one or more of your IRS tax periods may <b>expire within the next 12 months</b> under the <b>Collection Statute Expiration Date (CSED)</b> &mdash; generally, the 10-year limit on IRS collection.</p>
                                        <p>If you choose to <b>wait for the statute to expire</b>, the <b>potential benefit</b> is that the IRS may lose the right to collect that balance after the deadline.</p>
                                        <p>However, there are <b>significant risks</b>:</p>
                                        <ul>
                                            <li>The IRS may take <b>enforcement action</b> before the statute expires (for example, issuing a levy, wage garnishment, or lien).<br /> </li>
                                            <li>Certain actions, like submitting an Offer in Compromise, requesting an installment agreement, filing bankruptcy, or leaving the U.S. for an extended time, can <b>extend or pause (</b><b>&ldquo;</b><b>toll&rdquo;)</b> the expiration date.<br /> </li>
                                            <li>Waiting provides <b>no guarantee</b> the IRS won&rsquo;t act before expiration.<br /> </li>
                                        </ul>
                                        <p>EasAly AI provides this information for <b>educational purposes only</b>. This does <b>not constitute legal or tax advice</b>. You should consult a licensed tax professional to evaluate your options before deciding to wait for the statute to run.</p>
                                    </div>
                                }


                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ArrowDropDownIcon />}
                            aria-controls="panel2-content"
                            id="panel2-header"
                        >
                            <Typography component="span">✅ User Acknowledgment Checkbox</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>
                                <b>Do you wish to wait until the most recent statute of limitations expires before setting up relief?</b>
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                </div>
            </div>
        )
    }

}

export default CSEDDisclaimer;